const Colors = {
    primary: "#5dfc0a",
    danger: "#ff0033"
}

export default Colors;